var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectFloor7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2500,
    height: 1270,
    viewBox: "0 0 2500 1270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: 3,
    d: "M330 299V574.5H423V601H712.5V758H848V601H826.5V288L759.5 221H669V299H330Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: 2,
    d: "M712.5 601V758H642V738.5H418V1159.5H56L52 574.5H423V601H712.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: 1,
    d: "M673 1159.5H418V740H641.5V836H673V1159.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: 4,
    d: "M971 758H848V600H825.5V288L758 220.5L962 14.5L1238.5 294V719.5H1115V738H971V758Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: 8,
    d: "M1352.5 740V730H1238.5L1239 295.5H1501V300H1545V328.5H1516.5V582H1543V655.5H1516.5V730H1457.5V740H1352.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: 5,
    d: "M971 857.5V758V738H1115V719.5H1238.5V857.5V1160H950.5V857.5H971Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: 7,
    d: "M1515 856.5V1160H1239V730H1353V740.5H1458V730H1579.5V856.5H1515Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: 6,
    d: "M1801.5 730H1579V857H1514.5V1160.5H1500.5V1222H1782.5V879.5H1801.5V730Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: 9,
    d: "M1501 213V295.5V300.5H1545V328.5H1516.5V582.5H1543V656H1707.5H1779V642H1792V213H1501Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: 10,
    d: "M1803.5 642H1791.5V213H2068V592H2054.5V657H1803.5V642Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: 11,
    d: "M2054.5 729.5V657.5V591.5H2068.5V213H2360.5V298H2443.5V729.5H2054.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: 12,
    d: "M1900.5 729.5H2054.5H2443.5V1163H2359V1222.5H2060.5V878.5H1900.5V729.5Z",
    fill: "#F4CD2D",
    fillOpacity: 0.2,
    stroke: "#F4CD2D",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectFloor7);
export default __webpack_public_path__ + "static/media/select-floor-7.f9d02c7d.svg";
export { ForwardRef as ReactComponent };